<template>
          
    <div class="vertFlex tclass">
        <div class="horizFlexStretch bottomborder">
            <label class="  " for  v-html="getLeftText"> </label>
            <label class="  " for > {{getRightText}}</label>
            <!-- <label class=" " for>{{toDate(ticket.startDateTime)}}</label> -->
            
        </div>
        
        <!-- NOT SPLIT -->
         <div v-if="!ticketIsSplit">
            <!-- if we have prep areas, divide by them -->
            <div v-if="usingPrepAreas" class="margintop">
                <div v-for="pa in prepAreas" :key="pa.id" :value="pa.id" class="" >
                    <div v-if="areaHasItems(pa.name)">
                        <label class="bold " >{{pa.name}}</label>
                        <div v-for="li in lineItemsByArea(pa.name)" :key="li.id" :value="li.id" class="tliclass indentsmall" >
                            <div class="horizFlex">
                                
                                <label class="lineitemlabel " for>{{getProductString(li)}}</label>
                                <img src="@/assets/fire.png" class="fireimg" v-if="li.isInKitchen"/>
                            </div>
                            
                            <div class="indent">
                                <label v-if="li.productOptionsString!=null">{{ li.productOptionsString }}</label>
                            </div>
                            <div class="indent">
                                <label class="lineitemlabel " for>{{li.optionNote}}</label>
                            </div>
                            
                        </div>
                    </div>
                    
                    
                </div>
                <label class="bold " v-if="areaHasItems(null)">Other</label>
                <div v-for="li in lineItemsByArea(null)" :key="li.id" :value="li.id" class="tliclass indentsmall" >
                    <div class="horizFlex">
                                
                        <label class="lineitemlabel " for>{{getProductString(li)}}</label>
                        <img src="@/assets/fire.png" class="fireimg" v-if="li.isInKitchen"/>
                    </div>
                            
                    <div class="indent">
                        <label v-if="li.productOptionsString!=null">{{ li.productOptionsString }}</label>
                    </div>
                    <div class="indent">
                        <label class="lineitemlabel " for>{{li.optionNote}}</label>
                    </div>
                </div>
            </div>


            <div v-for="li in ticket.lineItems" :key="li.id" :value="li.id" class="tliclass" v-if="!usingPrepAreas" >
                <label class="lineitemlabel" >{{getProductString(li)}}</label>
                <img src="@/assets/fire.png" class="fireimg" v-if="li.isInKitchen"/>
                <div class="indent">
                    <label v-if="li.productOptionsString!=null">{{ li.productOptionsString }}</label>
                </div>
                <div class="indent">
                        <label class="lineitemlabel " for>{{li.optionNote}}</label>
                </div>
                
            </div>
        
        
            

            <div v-for="ti in ticket.tipItems" :key="ti.id" :value="ti.id" class="tliclass" >
                <label class="lineitemlabel " for>Tip: $ {{ti.amount}}</label>
        
                
            </div>


            <div class="vertFlex totaldiv " v-if="showTotals">
                <label for class=" totallabel">Subtotal: {{ ticket.subTotal|toCurrency }}</label>
                <label for class=" totallabel discountcolor">Discount: {{ ticket.discountAmount|toCurrency }}</label>
                <label for class=" totallabel">Tax: {{ ticket.tax|toCurrency }}</label>
                <label for class=" totallabel">Tip: {{ ticket.tipTotal|toCurrency }}</label>
                <label for class=" totallabel">Total: {{ ticket.total|toCurrency }}</label>
            </div>
                        

                        
            <div class="piclass" v-for="pi in ticket.paymentItems" :key="pi.id" :value="pi.id"  >
                <div class="horizFlexStretch">
                    <label class="leftjustified">{{ pi.typeName }}</label>
                    <label class="leftjustified">{{ pi.numberData }}</label>
                    <label class="rightjustified">{{amount(pi)}}</label>
                </div>
                <div v-if="pi.changeGiven>0" class="horizFlexStretch">
                    <label class="leftjustified leftmargin">change: </label>
                    <label class="rightjustified">{{change(pi)}}</label>
                </div>
                
            </div>
            <linkbutton toplabel="Print Receipt" @click="printreceiptforguest(null)" v-if="showPrintReceipt"/>
         </div>

        
         <!-- SPLIT -->
         <div v-else-if="ticketIsSplit">
            
            <div v-for="li in getGuestTotals" :key="li.name" :value="li.name" v-if="li.total>0">
                <label for class=" bold">{{ li.name }}</label>

                <div v-for="l in ticket.lineItems" :key="l.id" :value="l.id" class="tliclass" v-if="l.guestNumber==li.name">
            
                    <label class="lineitemlabel " for>{{getProductString(l)}}</label>
                    <img src="@/assets/fire.png" class="fireimg" v-if="l.isInKitchen"/>
                    <div class="indent">
                        <label v-if="li.productOptionsString!=null">{{ li.productOptionsString }}</label>
                    </div>
                    <div class="indent">
                            <label class="lineitemlabel " for>{{li.optionNote}}</label>
                    </div>
                    
                </div>
                <div v-for="ti in ticket.tipItems" :key="ti.id" :value="ti.id" class="tliclass"  v-if="ti.guestNumber==li.name">
                    <label class="lineitemlabel " for>Tip: $ {{ti.amount}}</label> 
                </div>

                

                <div class="vertFlex totaldiv " v-if="showTotals">

                    <label for class="totallabel">Subtotal: {{ getGuestSubTotal(li.name) }}</label>
                    <!-- <label for class="totallabel">Change: {{ change_byGuest(li.name)|toCurrency }}</label> -->
                     <label for class=" totallabel discountcolor">Discount: {{ getGuestDiscount(li.name) }}</label> 
                     <label for class=" totallabel">Tax: {{ getGuestTax(li.name) }}</label> 
                     <label for class=" totallabel">Tip: {{ getGuestTip(li.name) }}</label> 
                    <label for class=" totallabel">Total: {{ getGuestTotal(li.name) }}</label> 
                </div>

                <div class="piclass " v-for="pi in ticket.paymentItems" :key="pi.id" :value="pi.id"  v-if="pi.guestNumber==li.name">
                    <div class="horizFlexStretch">
                        <label class="leftjustified">{{ pi.typeName }}</label>
                        <label class="leftjustified">{{ pi.numberData }}</label>
                        <label class="rightjustified">{{amount(pi)}}</label>
                    </div>
                    <div v-if="pi.changeGiven>0" class="horizFlexStretch">
                        <label class="leftjustified leftmargin">change: </label>
                        <label class="rightjustified">{{change(pi)}}</label>
                    </div>
                    
                </div>
                 <linkbutton toplabel="Print Receipt" @click="printreceiptforguest(li.name)" v-if="showPrintReceipt"/>
                <hr class="thickbottomborder">
            </div>

            
        </div>



        <linkbutton toplabel="Print Ticket" @click="printticketasreceiptdirect()" v-if="showPrintTicket"/>
       
    </div>
                            
</template>
    
    <script>
    import format from '../../style/format.js'
    import linkbutton from '../controls/linkbutton.vue'
    export default {
        name:'ticketv',
        components:{
            linkbutton,

        },
        props:{
           
            ticket:{
                type:Object,
                default:null
            },
            prepAreas:{
                type:Array,
                default:[]
            },
            showTotals:{
                type:Boolean,
                default:true
            }
            
        },
        mixins:[format],
       
        data(){
            return{
              
            }
        },
        computed:{
            showPrintReceipt(){
                return this.ticket.statusName.includes('InService') || this.ticket.statusName.includes('CheckedOut')
            },
            showPrintTicket(){
                return this.ticket.statusName.includes('Kitchen')
            },
            fireimage(){
                return '@/assets/pencil.png'
            },
            usingPrepAreas(){
                return this.prepAreas.length>0
            },
            productsAsSeparateItems(){
                if(window.PRODUCTS_AS_SEPARATE_ITEMS==undefined){return false}
                else{return window.PRODUCTS_AS_SEPARATE_ITEMS}
            },
            getLeftText(){
                var name=null
                //console.log('gname ' + this.ticket.guestName)
                if(this.ticket.TakeOutGuestName!=null){return 'Takeout'}//{return this.ticket.TakeOutGuestName}
                else {name= this.ticket.employeeName}
                
                //make name first + last initial
                if(name!=null){
                    var index = name.indexOf(' ')
                    var first = name.substring(0,index)
                    var last = name.substring(index + 1, index + 2)
                    name = first + ' ' + last
                }
                

                if(this.ticket.TableNumber!=null){
                    if(this.ticket.TableNumber>0){
                        if(name==null){name='<b>T' + this.ticket.TableNumber + '</b>'} 
                        else{name = '<b>T' + this.ticket.TableNumber + '</b> / ' + name }
                    }
                    
                }
                return name
            },
            getRightText(){
               if(this.ticket.TakeOutGuestName!=null){return this.ticket.TakeOutGuestName}
               else if( this.ticket.guestName!=null && !this.ticket.guestName.includes('T:')){
                return this.ticket.guestName
               }else{
                return this.$options.filters.formatTime_NoSeconds( this.ticket.startDateTime)
               }
            },
            ticketIsSplit(){
                return this.ticketIsSplit_byTicket(this.ticket)
            },
            getGuestTotals(){
                //console.log('get guest totals')
                var lasthadtotal=true
                var guestTotals = []

                for (let i = 1; i <= 20; i++) {
                var n = "Guest " + i
                var t = this.getGuestTotal(n)
                var p = this.getGuestTotalPaid(n)
                var d = this.due_byGuest(n)
                var c = this.change_byGuest(n)
                var g1 = {
                    name:n,
                    total:t,
                    totalpaid:p,
                    due:d,
                    change:c,
                    show:lasthadtotal || i==1 || i==2
                }

                guestTotals.push(g1)
                lasthadtotal=t>0
                }
                
                return guestTotals
            },
        },
        methods:{
            lineItemsByArea(pa){
                var items=[]
                this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    //console.log('pstring ' + li.productPrepAreaString)
                    if(li.productPrepAreaString==null ){
                        if( pa==null){items.push(li)} 
                    }
                    else if(li.productPrepAreaString.includes(pa) ){
                        items.push(li)
                    }
                    
                } 
                return items
            },
            areaHasItems(pa){
               // console.log(pa)
                var hasitems=false
                this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.productPrepAreaString!=null){
                        if(li.productPrepAreaString.includes(pa) ){
                            hasitems=true
                        }
                    }else{
                        if(li.productPrepAreaString==null && pa==null){
                            hasitems=true
                        }
                    }
                    
                } 
                return hasitems
            },
            getProductString(li){
                if(this.productsAsSeparateItems){
                    var pstring = 'S' + li.seatNumber + ' ' + li.productName
                }else{
                    var pstring = li.quantity + ' ' + li.productName
                }
                
                /* if(li.isInKitchen){
                    pstring = pstring + ' (Fired)'
                } */
                /* if(li.productPrepAreaString!=null){
                    pstring = pstring + " (" + li.productPrepAreaString + ")"
                } */
                return pstring
            },
            amount(pi){
                var amt = pi.amount
                /* if(pi.changeGiven>0){
                     amt = pi.amount - pi.changeGiven
                } */
                return this.$options.filters.toCurrency(amt)
            },
            change(pi){
                var amt = pi.changeGiven
                return this.$options.filters.toCurrency(amt)
            },
            toCurrency(amt){
                return this.$options.filters.toCurrency(amt)
            },
            toDate(dt){
                return this.$options.filters.formatTime_NoSeconds(dt);
            },
            
        
            tclass(g){
                let c = "tclass"
                return c
            },
            
           async printticketasreceiptdirect(){
                console.log('print ticket')
                this.$emit('print')
           },
           async printreceiptforguest(guestNumber){
                console.log('print receipt')
                this.$emit('printreceipt',guestNumber,this.ticket)

                

           },
           //split ticket support
           ticketIsSplit_byTicket(t){
                var issplit=false
                if(t.lineItems!=undefined){
                    t.lineItems.forEach(myFunction2)
                    
                        function myFunction2(item, index, arr) {
                            let li=arr[index]
                            if(li.guestNumber!=null ){
                                issplit=true
                            }
                        } 
                    }
                    return issplit
            },
            
            getGuestTotal(guestnumber){
                var total=Number(this.getGuestSubTotal(guestnumber))
                total = total + Number(this.getGuestTax(guestnumber))
                total = total + Number(this.getGuestTip(guestnumber))
                total = total - Number(this.getGuestDiscount(guestnumber))
                /* if(this.ticket.lineItems!=undefined){
                this.ticket.lineItems.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let li=arr[index]
                        if(li.guestNumber==guestnumber ){
                            total = total + li.amount + li.tax
                        }
                    } 
                } */
                
                //console.log('gtotal ' + total)
                return total.toFixed(2)
            },
            getGuestSubTotal(guestnumber){
                var total=0
                if(this.ticket.lineItems!=undefined){
                this.ticket.lineItems.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let li=arr[index]
                        if(li.guestNumber==guestnumber ){
                            total = total + li.amount 
                        }
                    } 
                }
                
                // console.log('gtotal ' + total)
                return total.toFixed(2)
            },
            getGuestTax(guestnumber){
                var total=0
                if(this.ticket.lineItems!=undefined){
                this.ticket.lineItems.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let li=arr[index]
                        if(li.guestNumber==guestnumber ){
                            total = total + li.tax 
                        }
                    } 
                }
                
                // console.log('gtotal ' + total)
                return total.toFixed(2)
            },
            getGuestDiscount(guestnumber){
                var total=0
                if(this.ticket.lineItems!=undefined){
                this.ticket.lineItems.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let li=arr[index]
                        if(li.guestNumber==guestnumber ){
                            total = total + li.discountAmount 
                        }
                    } 
                }
                
                // console.log('gtotal ' + total)
                return total.toFixed(2)
            },
             getGuestTip(guestnumber){
                var total=0
                if(this.ticket.tipItems!=undefined){
                this.ticket.tipItems.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let li=arr[index]
                        if(li.guestNumber==guestnumber ){
                            total = total + li.amount 
                        }
                    } 
                }
                
                // console.log('gtotal ' + total)
                return total.toFixed(2)
            },
          getGuestTotalPaid(guestnumber){
            var total=0
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==guestnumber ){
                        total = total + li.amount
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return total.toFixed(2)
          },
          payTotal_byGuest(name){
        var pd = this.getGuestTotalPaid(name)
      
        return pd
      },
      due_byGuest(name){
         var pd = this.getGuestTotalPaid(name)
        var owed = this.getGuestTotal(name)
        var due = (Number(owed) - Number(pd)).toFixed(2)
        if(due<0){due='0.00'}
        return due
      },
      change_byGuest(name){
        var change=0
            if(this.ticket.paymentItems!=undefined){
              this.ticket.paymentItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==name ){
                        change = change + li.changeGiven
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return change.toFixed(2)
      },
                
        }
    }
    
    </script>
    
    <style>
    .indent{
        margin-left: 10px;
        font-size: smaller;
    }
    .indentsmall{
        margin-left: 5px;
    }
    .tclass{
        font-size:medium;
        width:200px;
        margin:5px;
        border:1px solid gray;
        text-align:left;
        padding:5px;
        border-radius:5px;
    }
    .tliclass{
        /* border-bottom:1px solid lightgray; */
        text-align:left;
        padding:10px 0px 10px 0px;
 
    }
    .piclass{
        text-align:left;
        padding:2px 0px 2px 0px;
    }
    .bottomborder{
        border-bottom:1px solid gray;
        
    }
    .leftmargin{
        margin-left:10px;
    }
    .lineitemlabel{
      
    }
    .totaldiv{
        padding-top:5px;
        border-top:1px solid gray;
    }
    .totallabel{
        text-align: right;
        
    
    }
    .thickbottomborder{
        border-bottom:2px solid black;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    